import { StoreAction, ApiError } from '../../models/rootState.model';
import { ContributorJob } from 'src/app/models/contributor-jobs.model';
// tslint:disable: class-name

// Types
export const JOBS_ACTION_TYPES = {
    LOAD: '[Jobs] - Load Jobs requested-',
    LOADED: '[Jobs] - Loaded Jobs-',
    ERROR: '[Jobs] - Error loafing jobs'
};

// Classes

export class Action_Jobs_Load implements StoreAction<any> {
    readonly type = JOBS_ACTION_TYPES.LOAD;
}

export class Action_Jobs_Loaded implements StoreAction<any> {
    readonly type = JOBS_ACTION_TYPES.LOADED;
    constructor(public payload: ContributorJob[]) { }
}

export class Action_Jobs_LoadError implements StoreAction<any> {
    readonly type = JOBS_ACTION_TYPES.ERROR;
    constructor(public payload: string) { }
}



